import Color from '@tiptap/extension-color';
import Highlight from '@tiptap/extension-highlight';
import TextStyle from '@tiptap/extension-text-style';
import Underline from '@tiptap/extension-underline';
import { Editor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import { prosemirrorJSONToYXmlFragment, yXmlFragmentToProsemirrorJSON } from 'y-prosemirror';
import type { XmlFragment as YXmlFragment } from 'yjs';

import { ListStylePropagation } from './extensions/ListStylePropagation';
import { BaseTooltipMark } from './extensions/Tooltip/Tooltip';
import { WrapContentInSpan } from './extensions/WrapContentInSpan';
import { CustomLink } from './extensions/customLink';
import { FontFamily } from './extensions/fontFamily';
import { FontSize } from './extensions/fontSize';
import { Heading } from './extensions/heading';
import { Image } from './extensions/image';
import { LineHeight } from './extensions/lineHeight';
import { TextDirection } from './extensions/textDirection';

type GetDefaultExtensionsOptions = {
  useNativeHistory?: boolean;
};

export const getDefaultExtensions = (options?: GetDefaultExtensionsOptions) => {
  const { useNativeHistory = true } = options ?? {};
  return [
    Color,
    CustomLink,
    FontFamily,
    FontSize,
    LineHeight,
    Highlight.configure({
      multicolor: true
    }),
    Image,
    useNativeHistory
      ? StarterKit.configure({ heading: false })
      : StarterKit.configure({ heading: false, history: false }),
    TextDirection.configure({
      types: ['heading', 'paragraph']
    }),
    WrapContentInSpan,
    ListStylePropagation,
    TextStyle,
    Underline,
    BaseTooltipMark,
    Heading
  ];
};

export const htmlToXmlFragment = (content: string) => {
  const editor = new Editor({
    extensions: getDefaultExtensions(),
    content
  });

  const schema = editor.schema;
  const jsonContent = editor.getJSON();

  return prosemirrorJSONToYXmlFragment(schema, jsonContent);
};

export const yXmlFragmentToText = (fragment: YXmlFragment) => {
  const content = yXmlFragmentToProsemirrorJSON(fragment);
  const editor = new Editor({
    extensions: getDefaultExtensions(),
    content
  });

  return editor.getText();
};
